import React from 'react';
import Topbar from './Topbar';
import Footer from './Footer';

export default function ThankYou() {
    return (
        <div>
        <Topbar />
        <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Thank You</h2>
            <p className="mt-2 text-lg/8 text-gray-600">We'll be in touch soon.</p>
            </div>
        </div>
        <Footer />
        </div>
    )
}   